var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeneficiary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#6F00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.447 12.2151C20.3804 12.2083 20.3137 12.2083 20.2471 12.2151C19.2373 12.1674 18.4391 11.3351 18.4391 10.312C18.4391 9.26001 19.2929 8.4 20.3511 8.4C21.4026 8.4 22.2624 9.25312 22.2631 10.3107C22.2558 11.3357 21.456 12.1674 20.447 12.2151Z",
    fill: "#D9CDFF",
    stroke: "#D9CDFF",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8171 17.8275L22.8169 17.8276C22.1449 18.2777 21.2221 18.5012 20.3002 18.4763C20.4925 17.911 20.593 17.3083 20.5995 16.6842L20.5995 16.6842V16.68C20.5995 16.0259 20.4898 15.3928 20.2757 14.8083C21.2103 14.7797 22.1324 15.0033 22.8103 15.4533L22.8103 15.4533L22.8116 15.4541C23.36 15.8151 23.5798 16.252 23.5805 16.6377C23.5812 17.0238 23.3625 17.4627 22.8171 17.8275Z",
    fill: "#D9CDFF",
    stroke: "#D9CDFF",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5521 12.616C11.6081 12.608 11.6641 12.608 11.7201 12.616C12.9601 12.576 13.9441 11.56 13.9441 10.312C13.9441 9.032 12.9121 8 11.6321 8C10.3601 8 9.32812 9.032 9.32812 10.312C9.32812 11.56 10.3121 12.576 11.5521 12.616Z",
    fill: "#D9CDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.644 16.68C11.644 17.456 11.812 18.192 12.116 18.856C10.988 18.976 9.812 18.736 8.948 18.168C7.684 17.328 7.684 15.96 8.948 15.12C9.804 14.544 11.012 14.312 12.148 14.44C11.82 15.112 11.644 15.872 11.644 16.68Z",
    fill: "#D9CDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0982 19.096C16.0342 19.088 15.9622 19.088 15.8902 19.096C14.4182 19.048 13.2422 17.84 13.2422 16.352C13.2502 14.832 14.4742 13.6 16.0022 13.6C17.5222 13.6 18.7542 14.832 18.7542 16.352C18.7462 17.84 17.5782 19.048 16.0982 19.096Z",
    fill: "#D9CDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 20.752C12.2917 21.56 12.2917 22.888 13.4997 23.688C14.8758 24.608 17.1318 24.608 18.5078 23.688C19.7158 22.88 19.7158 21.552 18.5078 20.752C17.1398 19.832 14.8837 19.832 13.4997 20.752Z",
    fill: "#D9CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficiary);
export default __webpack_public_path__ + "static/media/beneficiary.7c51afc941ac64f0c1abf20d4c78e111.svg";
export { ForwardRef as ReactComponent };